import React, { useState, useEffect, useCallback } from 'react';
import Icon from '../../Components/Icons/Icon';
import { useSession } from '../../Components/Session';
import GlobalSearch from '../../Components/GlobalSearch';
import { useAssistantContext } from '../../Components/Assistant';
import Nav from '../Desktop/Nav';
import RedesignSearchField from '../shared/RedesignSearchField';
import RedesignNavSections from '../shared/RedesignNavSections';
import TabletNavDrawer from '../shared/TabletNavDrawer';
import { useNavigate } from 'react-router-dom';

const TabletNav = () => {
    const [menuOpen, setMenuOpen] = useState(false);
    const [globalSearchOpen, setGlobalSearchOpen] = useState(false);
    const { showRedesign } = useSession();
    const { assistantOpen, setAssistantOpen, unseen } = useAssistantContext();
    const navigate = useNavigate();

    const closeMenu = useCallback(() => setMenuOpen(false), []);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
                e.preventDefault();
                setGlobalSearchOpen(true);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    return (
        <>
            <div className="fixed left-0 top-1/2 z-30 print:hidden -translate-y-1/2 flex flex-col items-center gap-4 py-3 pl-2 pr-2 rounded-r-xl surface-1 shadow-md border border-l-0 border-gray-200 dark:border-slate-600 text-slate-700 dark:text-slate-100 fill-slate-700 dark:fill-slate-100">
                <button
                    type="button"
                    className="hover:opacity-90 transition-opacity"
                    onClick={() => setMenuOpen(true)}
                    aria-label="Open menu"
                >
                    <Icon icon="Bars" size="1x" />
                </button>
                <button
                    type="button"
                    className="hover:opacity-90 transition-opacity"
                    onClick={() => setGlobalSearchOpen(true)}
                    aria-label="Open search"
                >
                    <Icon icon="MagnifyingGlass" size="1x" />
                </button>
                <button
                    type="button"
                    className="hover:opacity-90 transition-opacity"
                    onClick={() => navigate('/')}
                    aria-label="Go to home"
                >
                    <Icon icon="HouseChimney" size="1x" />
                </button>
                <button
                    type="button"
                    className="hover:opacity-90 transition-opacity"
                    onClick={() => setAssistantOpen(!assistantOpen)}
                    aria-label="Open Sid assistant"
                >
                    <Icon
                        theme="soapy"
                        icon={assistantOpen || unseen ? 'SidSolid' : 'SidLight'}
                        size="1x"
                    />
                </button>
            </div>

            <TabletNavDrawer isOpen={menuOpen} onClose={closeMenu}>
                {showRedesign ? (
                    <>
                        <RedesignSearchField
                            onOpen={() => {
                                setGlobalSearchOpen(true);
                                setMenuOpen(false);
                            }}
                        />
                        <nav className="mt-2">
                            <RedesignNavSections onNavigate={closeMenu} />
                        </nav>
                    </>
                ) : (
                    <div className="pt-1">
                        <Nav embedded />
                    </div>
                )}
            </TabletNavDrawer>

            <GlobalSearch isOpen={globalSearchOpen} setIsOpen={() => setGlobalSearchOpen(false)} />
        </>
    );
};

export default TabletNav;
